import { TGetFooterInfoListResponse } from '@/services';

import { formatDate, map } from 'utils';

export const formatFooterInfoDetail = (
	input: TGetFooterInfoListResponse[number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt),
	};
};

export const formatFooterInfoList = (input: TGetFooterInfoListResponse) => {
	return map(input, formatFooterInfoDetail);
};
